import $ from "jquery";

class Empresa {
  constructor(loading) {
    this.loading = loading;
    

    if (document.querySelector("#registar-empresa")) {
      this.newCompany = document.querySelector("#registar-empresa");
    }

    if (document.querySelector("#aprovar-empresa")) {
      this.aproveComanyBtn = document.querySelector("#aprovar-empresa");
    }

    if (document.querySelector("#actualizar-empresa")) {
      this.updateComanyBtn = document.querySelector("#actualizar-empresa");
    }

    this.events();

    let countries = [];

  }

  events() {
    if (this.newCompany) {
      this.newCompany.addEventListener("click", this.saveCompany.bind(this));
    }

    if (this.aproveComanyBtn) {
      this.aproveComanyBtn.addEventListener("click", (e) =>
        this.aproveComany.bind(this)(e)
      );
    }

    $("#empresas").on("click", ".aprovar", (e) =>
          this.aproveComany.bind(this)(e)
    );

    $("#empresas").on("click", ".reprovar", (e) =>
          this.reproveComany.bind(this)(e)
    );
    
    if (this.updateComanyBtn) {
      this.updateComanyBtn.addEventListener("click", (e) =>
        this.updateCompany.bind(this)(e)
      );
    }

    if (document.querySelector("#search-empresa")) {
      let search_empresa = document.querySelector("#search-empresa");
      search_empresa.addEventListener("keyup", this.searchEmpresa.bind(this));
    }

    if (document.querySelector("#country")) {
      this.getCountryPhoneCode.bind(this)();

      let country = document.querySelector("#country");

      country.addEventListener("click", this.handlePhoneCodeList);
      $("#phone-codes-list").on("click", ".item", (e) =>
        this.selectCountry.bind(this)(e)
      );
      // $("#phone-codes-container").on("mouseout",  this.handlePhoneCodeList);
      $("#search-countries").on("keyup", this.searchCountries.bind(this));
    }
  }

  selectCountry(e) {
    let elemet = e.target;

    let phoneCode = $(elemet).find("span.code").first().text();
    let imgUrl = $(elemet).find("img").first().attr("src");

    $("#img-flag").attr("src", imgUrl);
    $("#code").text(phoneCode);

    this.handlePhoneCodeList();
  }

  searchCountries() {
    let search = this.normalizeString($("#search-countries").val());

    let result = this.countries.filter((country) => {
      let string = `${country.name} ${country.phone}`;
      string = this.normalizeString(string.toLowerCase());
      search = search.toLowerCase();

      // Check if the query matches either the first name or last name
      return string.includes(search);
    });

    this.updateCountryList(result);
  }

  normalizeString(str) {
    return str
      .normalize("NFD") // Normalize string to decomposed form
      .replace(/[\u0300-\u036f]/g, ""); // Remove accents
  }

  getCountryPhoneCode() {
    fetch("https://restcountries.com/v3.1/all")
      .then((response) => response.json())
      .then((data) => {
        this.countries = data.map((country) =>
          country.idd.suffixes && country.idd.suffixes.length == 1
            ? {
                name: country.translations.por.common,
                flag: country.flags.svg,
                code: country.cca2,
                phone: country.idd.root + country.idd.suffixes,
              }
            : {
                name: country.translations.por.common,
                flag: country.flags.svg,
                code: country.cca2,
                phone: country.idd.root,
              }
        );

        this.countries.sort((a, b) => a.name.localeCompare(b.name));

        this.updateCountryList(this.countries);
      })
      .catch((error) => {
        // Handle any errors that occur during the API request
        console.log("Error fetching country data:", error);
      });
  }

  updateCountryList(countries) {
    const list = countries.map(
      (country) => `
      <div class="item">
          <img class="country-flag" src="${country.flag}" alt=""> &nbsp;&nbsp;
          <span>${country.name} </span> &nbsp;&nbsp;
          <span class="code">${country.phone}</span>
      </div>
      `
    );

    $("#phone-codes-list").html(list);
  }

  handlePhoneCodeList() {
    $("#phone-codes-container").toggleClass("d-none");
  }

  searchEmpresa() {
    let search = $("#search-empresa").val();
    let activo = $("#search-empresa").data("estado") == "pendente" ? "0" : 1;

    $.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/empresa/v1/search",
      method: "POST",
      beforeSend: xhr => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      data: {
        search,
        activo,
      },
      success: (response) => {
        $("#empresa-list").html(this.empresaHtml(response));
      },
      error:  error => {
        console.log("Error creating user.");
        console.log(error);
      },
    });
  }

  empresaHtml(empresas) {
    let html = "";

    if (empresas.length) {
      empresas.map((empresa) => {
        $("#empresa-list").addClass("space-between");
        html += `
        <div class="student__card">
          <div class="student__card-up">
              <a href="${empresa.link}">ver</a>
              <h2 class="title">${empresa.nome_da_empresa}</h2>
          </div>

          <div class="student__card-bottom">

              <h4>${empresa.sector}</h4> <br>
              <span>${empresa.nome_do_representante}</span> <br>
              <p>${empresa.enderenco_fisico}</p>
          </div>
      </div>
    
        `;
      });
    } else {
      $("#empresa-list").removeClass("space-between");
      html += `
        <div class="centered h-25 w-100"  >
            <h2 class="text-secondary">Nenhum empresa foi encontrado!</h2>
        </div>
      `;
    }

    return html;
  }



  saveCompany() {

    
    
    Swal.fire({
      title: "Confirmar",
      text: "Tens certeza que queres proceder?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      customClass: {
        content: "my-swal-content",
        popup: "my-swal-container",
        confirmButton: "confirm-swal-button",
        cancelButton: "cancel-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {


        let nome_da_empresa = $("#nome_da_empresa").val();
        let nome_do_representante = $("#nome_do_representante").val();
        let enderenco_fisico = $("#enderenco_fisico").val();
        let provincia = $("#provincia").val();
        let distrito = $("#distrito").val();
        let nuit = $("#nuit").val();
        let telefone = $("#telefone").val();
        let country_flag = $("#img-flag").attr("src");
        let phoneCode = $("#code").text();
        let email = $("#email").val();

        let sector_de_actividade = $("#sector_de_actividade").val();

        console.log("sector", sector_de_actividade);
        console.log("phoneCode", phoneCode);
        console.log("country_flag", country_flag);
        

        if (
          nome_da_empresa &&
          nome_do_representante &&
          enderenco_fisico &&
          provincia &&
          distrito &&
          nuit &&
          telefone &&
          email &&
          sector_de_actividade
        ) {
         
          this.loading.showLoadingAnimation();

          let formData = new FormData();
          let alavaraFileInput = document.getElementById("alvara");
          let alvara = alavaraFileInput.files[0];

          let certidaoFileInput = document.getElementById(
            "certidao_registo_comercial"
          );
          let certidao = certidaoFileInput.files[0];

          formData.append("action", "upload_file");
          formData.append("alvara", alvara);
          formData.append("certidao", certidao);
           
          this.loading.hideLoadingAnimation()
          $.ajax({
            url: maisempregoData.ajaxurl, // WordPress AJAX endpoint
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: response => {

              console.log(response)
              let newCompany = {
                title: nome_da_empresa,
                status: "publish",
                post_type: "empresa",

                acf: {
                  nome_da_empresa,
                  nome_do_representante,
                  enderenco_fisico,
                  provincia,
                  distrito,
                  nuit,
                  telefone,
                  email,
                  phoneCode,
                  country_flag,
                  activo: 0,
                  sector_de_actividade,
                  alvara: response.data[0].alvara,
                  certidao_registo_comercial: response.data[1].certidao,
                },
              };

              

              $.ajax({
                beforeSend: (xhr) => {
                  // xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
                },
                url:
                  maisempregoData.root_url +
                  "/wp-json/maisemprego/empresa/v1/create-empresa",
                type: "POST",
                data: newCompany,
                success: (response) => {
                  console.log(response)
                  $("#nome_da_empresa").val(""),
                    $("#nome_do_representante").val(""),
                    $("#enderenco_fisico").val(""),
                    $("#provincia").val(""),
                    $("#distrito").val(""),
                    $("#nuit").val(""),
                    $("#telefone").val(""),
                    $("#email").val(""),
                    $("#sector_de_actividade").val(""),
                    $("#certidao_registo_comercial").val(""),
                    $("#alvara").val(""),

                    this.loading.hideLoadingAnimation()
                    Swal.fire(
                      "Sucesso!",
                      "Estamos a  verificar o seu registo, entraremos em contacto brevemente.",
                      "success"
                    ).then(() => {
                      // document.location.href = "/";
                    });
                },
                error: (response) => {
                  console.log(response)
                  this.loading.hideLoadingAnimation()
                  Swal.fire({
                    title: "Error",
                    text: "Ocorreu um erro ao salvar dados!",
                    icon: "error",
                    confirmButtonText: "OK",
                  });
                  console.log(response);
                },
              });
            },
            error: error =>{
              console.log(error)
              
              this.loading.hideLoadingAnimation()
              Swal.fire({
                title: "Error",
                text: "Ocorreu um erro durante o carregamento de ficheiros",
                icon: "error",
                confirmButtonText: "OK",
              });

              
            },
          });
        } else {
          this.loading.hideLoadingAnimation()
          Swal.fire({
            title: "Error",
            text: "Preencha correctamente todos os campos!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }

        return;
      }
    });
  }

  validarNuit(nuit) {
    $.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/empresa/v1/nuit",
      method: "POST",
      beforeSend: xhr => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      data: {
        nuit,
      },
      success: (response) => {
        if (response.status) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Este nuit já foi cadastrado!",
          });

          return false;
        }

        return true;
      },
      error:  error => {
        console.log("Error creating user.");
        console.log(error);
      },
    });
  }

  reproveComany(e){
      let postID = $(e.target).data('postid');
     
      $.ajax({
        beforeSend: (xhr) => {
          xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
        },
        url: maisempregoData.root_url + "/wp-json/wp/v2/empresa/" + postID,
        type: "GET",
        success: (empresa) => {

          let data = {
            acf: {
                nome_da_empresa: empresa.acf.nome_da_empresa,
                nome_do_representante: empresa.acf.nome_do_representante,
                enderenco_fisico: empresa.acf.enderenco_fisico,
                provincia: empresa.acf.provincia,
                distrito: empresa.acf.distrito,
                nuit: empresa.acf.nuit,
                telefone: empresa.acf.telefone,
                country_flag:  empresa.acf.country_flag,
                phonecode:  empresa.acf.phonecode,
                email: empresa.acf.email,
                sector: empresa.acf.sector,
                activo: 2,
            },
  
          };
  
          this.loading.showLoadingAnimation()
          $.ajax({
            beforeSend: (xhr) => {
              xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
            },
            url: maisempregoData.root_url + "/wp-json/wp/v2/empresa/" + postID,
            type: "POST",
            data: data,
            success: (response) => {
              console.log(response)
              this.loading.hideLoadingAnimation()
              $(e.target).parent().remove();
             
              Swal.fire("Sucesso!", "Empresa reprovada com sucesso!", "success");
            },
            error: (response) => {
              console.log(response)
              this.loading.hideLoadingAnimation()
              console.log("Sorry");
              Swal.fire({
                title: "Error",
                text: "Ocorreu um erro na reprovação da empresa",
                icon: "error",
                confirmButtonText: "OK",
              });
              
            },
          });
          
        },
        error: (response) => {
          console.log(response)
          this.loading.hideLoadingAnimation()
          console.log("Sorry");
          Swal.fire({
            title: "Error",
            text: "Ocorreu um erro na reprovação da empresa",
            icon: "error",
            confirmButtonText: "OK",
          });
          
        },
      });
  }

  aproveComany(e) {
    
    let postID = $(e.target).data('postid');

    $.ajax({
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      url: maisempregoData.root_url + "/wp-json/wp/v2/empresa/" + postID,
      type: "GET",
      success: (empresa) => {
        console.log(empresa)

      let username = empresa.acf.nome_da_empresa
      .replace(" ", "")
      .toLocaleLowerCase();

      let email =  empresa.acf.email;
      let role = "empresa"; // Role ID or slug

      this.loading.showLoadingAnimation()
      $.ajax({
        url:
          maisempregoData.root_url + "/wp-json/maisemprego/user/v1/create-user",
        method: "POST",
        beforeSend: xhr => {
          xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
        },
        data: {
          username: username,
          email: email,
          roles: [role], // Set the desired role for the user
        },
        success: user_id => {
          
          let data = {
            acf: {
                nome_da_empresa: empresa.acf.nome_da_empresa,
                nome_do_representante: empresa.acf.nome_do_representante,
                enderenco_fisico: empresa.acf.enderenco_fisico,
                provincia: empresa.acf.provincia,
                distrito: empresa.acf.distrito,
                nuit: empresa.acf.nuit,
                telefone: empresa.acf.telefone,
                country_flag:  empresa.acf.country_flag,
                phonecode:  empresa.acf.phonecode,
                email: empresa.acf.email,
                sector: empresa.acf.sector,
                user: user_id,
                activo: 1,
            },
  
          };
  
          $.ajax({
            beforeSend: (xhr) => {
              xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
            },
            url: maisempregoData.root_url + "/wp-json/wp/v2/empresa/" + postID,
            type: "POST",
            data: data,
            success: (response) => {
              console.log(response)
              this.loading.hideLoadingAnimation()
              $(e.target).parent().remove();
             
              Swal.fire("Sucesso!", "Empresa aprovada com sucesso!", "success");
            },
            error: (response) => {
              console.log(response)
              this.loading.hideLoadingAnimation()
              console.log("Sorry");
              Swal.fire({
                title: "Error",
                text: "Na aprovação da empresa",
                icon: "error",
                confirmButtonText: "OK",
              });
              
            },
          });
        },
        error:  error => {
          console.log(error)
          this.loading.hideLoadingAnimation()
          Swal.fire({
            title: "Error",
            text: "Na aprovação da empresa!",
            icon: "error",
            confirmButtonText: "OK",
          });
          console.log(error);
        },
      });

       
      },
      error: (response) => {
        console.log(response)
        this.loading.hideLoadingAnimation()
        console.log("Sorry");
        Swal.fire({
          title: "Error",
          text: "O correu um erro na aprovação da empresa",
          icon: "error",
          confirmButtonText: "OK",
        });
        
      },
    });
    
  }

  updateCompany(){

    this.loading.showLoadingAnimation()

    let postID = $("#post_id").val();
    let data = {
      acf: {
        nome_da_empresa: $("#nome_da_empresa").val(),
        nome_do_representante: $("#nome_do_representante").val(),
        enderenco_fisico: $("#enderenco_fisico").val(),
        provincia: $("#provincia").val(),
        distrito: $("#distrito").val(),
        nuit: $("#nuit").val(),
        telefone: $("#telefone").val(),
        country_flag:  $("#img-flag").attr("src"),
        phonecode:  $("#code").text(),
        email: $("#email").val(),
        sector: $("#sector_de_actividade").val(),
      },

    };

    $.ajax({
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      url: maisempregoData.root_url + "/wp-json/wp/v2/empresa/" + postID,
      type: "POST",
      data: data,
      success: (response) => {
        console.log(response)
        this.loading.hideLoadingAnimation()
        Swal.fire("Sucesso!", "Dados actualizados com sucesso!", "success");
      },
      error: (response) => {
        console.log(response)
        this.loading.hideLoadingAnimation()
        console.log("Sorry");
        Swal.fire({
          title: "Error",
          text: "Na aprovação da empresa",
          icon: "error",
          confirmButtonText: "OK",
        });
        
      },
    });
  }
}

export default Empresa;
